export const projectTools = [
  {
    id: 1,
    title: "React",
    image: require("../assets/images/services/tools_react.png"),
  },
  {
    id: 2,
    title: "Vue JS",
    image: require("../assets/images/services/tools_vue.png"),
  },
  {
    id: 3,
    title: "Node.js",
    image: require("../assets/images/services/tools_node.png"),
  },
  {
    id: 4,
    title: "Next.js",
    image: require("../assets/images/services/tools_nuxt.png"),
  },
  {
    id: 5,
    title: "PostgreSQL",
    image: require("../assets/images/services/tools_postgreSQL.png"),
  },
  {
    id: 6,
    title: "TypeScript",
    image: require("../assets/images/services/tools_react.png"),
  },
  {
    id: 7,
    title: "MongoDB",
    image: require("../assets/images/services/tools_spring.png"),
  },
  {
    id: 8,
    title: "Docker",
    image: require("../assets/images/services/tools_go.png"),
  },
];
